import React, { useState, useEffect } from 'react'

import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import { IconButton, Tooltip } from '@material-ui/core'
import { LinkOff } from '@material-ui/icons'

import { ReactComponent as ISee } from 'assets/ISee.svg'
import ConfirmActionModal from 'components/organisms/ConfirmActionModal'
import { useDispatch, useSelector } from 'react-redux'
import { unlinkCamera } from 'features/Cameras/camerasSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { useParams } from 'react-router'
import { getCamerasByAddress } from 'store/devices/operations'
import { useTranslation } from 'react-i18next'
import { DeviceServiceIcons } from 'components/atoms/DeviceServiceFormatted'
import { IconColors } from 'sputnik-icons'

const Camera = ({
  uuid,
  serial_number,
  onClick,
  children,
  selectArchiveDepth,
  cameraInfo,
}) => {
  const { t } = useTranslation('devices')
  const [confirmActionModal, setConfirmActionModal] = useState(false)
  const dispatch = useDispatch()
  const unlinking = useSelector(({ camerasNew }) => camerasNew.unlinking)

  const [deviceServices, setDeviceServices] = useState([])

  const archiveIcons = DeviceServiceIcons({
    color: IconColors.blue,
    style: {
      fontSize: '1.25rem',
      width: 24,
      height: 24,
    },
  })

  useEffect(() => {
    const servicesAll = []
    servicesAll.push('bitrate_1024')
    if (cameraInfo?.services) {
      setDeviceServices([...cameraInfo.services, ...servicesAll])
    } else {
      setDeviceServices(['archive_0', ...servicesAll])
    }
  }, [setDeviceServices, cameraInfo])
  const { entry, house } = useParams()
  return (
    <ListItem onClick={onClick} button>
      <ListItemIcon>
        <ISee />
      </ListItemIcon>
      <ListItemText primary={serial_number} />
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
        <ListItemSecondaryAction>
          <IconButton
            onClick={(e) => {
              e.stopPropagation()
              setConfirmActionModal(true)
            }}
          >
            <LinkOff color="error" />
          </IconButton>
        </ListItemSecondaryAction>
        <ListItemSecondaryAction>
          {deviceServices?.map((identifier) => (
            <IconButton
              key={identifier}
              onClick={() => selectArchiveDepth(uuid, true)}
              style={{
                padding: '4px',
                marginLeft: '0',
              }}
            >
              <Tooltip title="Change archive depth">
                {archiveIcons[identifier]}
              </Tooltip>
            </IconButton>
          ))}
        </ListItemSecondaryAction>
      </div>
      <ConfirmActionModal
        open={confirmActionModal}
        handleClose={(e) => {
          e.stopPropagation()
          setConfirmActionModal(false)
        }}
        handleAction={(e) => {
          e.stopPropagation()
          dispatch(unlinkCamera(uuid))
            .then(unwrapResult)
            .then(() => {
              dispatch(getCamerasByAddress(entry || house))
              setConfirmActionModal(false)
            })
        }}
        action={t('devices:cameras.unlink')}
        loading={unlinking}
      />
    </ListItem>
  )
}
export default Camera
